import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { setClassNameInDefns } from '../../common/definitionHelper';
import AfitdButton from '../../common/elemental/AfitdButton';

const styles = theme => ({
    root: {},
    buttonLabel: {},
    containedDefault: {},
    containedPrimary: {},
    containedSecondary: {},
});

const getDefns = params => {
    const { props } = params;
    const { classes, color = 'primary', ...otherProps } = props;
    const {
        ...otherClasses
    } = classes;

    let defns = {
        button: {
            variant: 'contained',
            color,
            ...otherProps,
        },
    };

    setClassNameInDefns(defns, otherClasses);

    return defns;
};

const InterviewActionButton = props => {
    //---------------------------------------------------------------------
    // From context and other hooks
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // Local states
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // From props
    //---------------------------------------------------------------------
    const { isHidden, startIcon, label, ...otherProps } = props;

    //---------------------------------------------------------------------
    // Derived
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // Side effects
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // Defns
    const defns = getDefns({ props: otherProps });
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // Render
    if (isHidden) {
        return null;
    } else {
        return (
            <AfitdButton startIcon={startIcon} {...defns.button}>
                {label}
            </AfitdButton>
        );
    }
    //---------------------------------------------------------------------
};

export default withStyles(styles)(InterviewActionButton);
